import { Component, OnInit, Inject} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
// import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-caste-master-popup',
  templateUrl: './caste-master-popup.component.html',
  styleUrls: ['./caste-master-popup.component.scss']
})
export class CasteMasterPopupComponent implements OnInit {
  CasteForm : FormGroup;
  CasteList: any;
  filteredCasteList: any;
  casteList: any[];
  dialogRef: MatDialogRef<any>;
  submitpayload: any;
  APIService: any;
  CasteCodefordelete;
  editButton = false;
  submitButton = true;
  deleteButton: boolean;
  constructor(
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    public router: Router,
    private httpClient: HttpClient,
    private dialogRef2: MatDialogRef<CasteMasterPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.fetchCertStatus();
    this.getCasteData();
    this.CasteCodefordelete = 0;
    this.submitButton = true;
    this.editButton = false;
    this.CasteForm = this.fb.group({
      // CasteId: new FormControl(''),
      CategoryId: new FormControl('',[Validators.required]),
      CasteName: new FormControl('',[Validators.required]),
      CasteCode: new FormControl(''),
      CasteNameM: new FormControl(''),
      CategoryIdDefault: new FormControl(''),
      CasteStat: new FormControl(''),
      EntryStat: new FormControl(''),
      EntryBy: new FormControl(''),

    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.deletee(this.data.selected);
    } else {
      // alert(this.data.key)
    }
  }

  fetchCertStatus() {
    this.spinner.show();
    const payload = {};
    // payload['CdType'] = 'CS';
    this.umsService.getCasteCategoryData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.CasteList = res.data;
        this.filteredCasteList = this.CasteList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  
  getCasteData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCasteData(payload).subscribe(res => {
      this.spinner.hide();
      this.casteList = res.data;
    });
  }

  submit() {
    if (this.CasteForm.invalid) {
      this.CasteForm.get('CategoryId').markAsTouched();
      this.CasteForm.get('CasteName').markAsTouched();
      return;
    } else {
      this.createCaste();
    }

  }



  createCaste() {
    this.spinner.show();
    this.submitpayload = this.CasteForm.value;
    this.submitpayload['CategoryId'] = this.submitpayload['CategoryId'];
    this.submitpayload['CasteName'] = this.CasteForm.value.CasteName;
    this.submitpayload['CasteCode'] = '';
    this.submitpayload['CasteNameM'] = '';
    this.submitpayload['CategoryIdDefault'] = '';
    this.submitpayload['CasteStat'] = '';
    this.submitpayload['EntryStat'] = '';
    this.submitpayload['EntryBy'] = '';
    // this.submitpayload['CasteId'] = 
    this.umsService.addCaste(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  update() {
    if (this.CasteForm.invalid) {
      this.CasteForm.get('CategoryId').markAsTouched();
      this.CasteForm.get('CasteName').markAsTouched();
      return;
    } else {
      this.updateCaste();
    }
  }

  updateCaste() {
    this.spinner.show();
    // let submitpayload = this.CasteForm.value;
    this.submitpayload = this.CasteForm.value;
    this.submitpayload['CategoryId'] = this.submitpayload['CategoryId'];
    this.submitpayload['CasteName'] = this.CasteForm.value.CasteName;
    this.submitpayload['CasteId'] = this.CasteForm.value.CasteId,
    this.submitpayload['CasteCode'] = '';
    this.submitpayload['CasteNameM'] = '';
    this.submitpayload['CategoryIdDefault'] = '';
    this.submitpayload['CasteStat'] = '';
    this.submitpayload['EntryStat'] = '';
    this.submitpayload['EntryBy'] = '';
    this.umsService.updateCaste(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }
  prepopulation(id) {
    const payload = {};
    payload['CasteId'] = id.CasteId;
    this.umsService.getCasteData(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = true;
        // this.isreadonly = true;
        this.submitButton = false;
        this.deleteButton = false;
        const cleanedCategoryId = data.CategoryId.replace(/\|/g, '');
        this.CasteForm = this.fb.group({
          CategoryId: new FormControl(cleanedCategoryId, [Validators.required]),
          CasteName: new FormControl(data.CasteName, [Validators.required]),
          CasteId: new FormControl(data.CasteId),
          CasteCode: new FormControl(data.CasteCode),
          CasteNameM: new FormControl(data.CasteNameM),
          CategoryIdDefault: new FormControl(data.CategoryIdDefault),
          CasteStat: new FormControl(data.CasteStat),
          EntryStat: new FormControl(data.EntryStat),
          EntryBy: new FormControl(data.EntryBy),
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        CategoryId: id.CategoryId,
        CasteName: id.CasteName,
        CasteId: id.CasteId,
        CasteCode: id.CasteCode,
        CasteNameM: id.CasteNameM,
        CategoryIdDefault: '',
        CasteStat: id.CasteStat,
        EntryStat: id.EntryStat,
        EntryBy: id.EntryBy,
      },
    };
    this.httpClient.delete(this.APIService + '/students/CasteMaster', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close()
        });
      });

  }


  deletee(k) {
    // this.list = false;
    this.getCasteData();
    const payload = {};

    payload['CasteId'] = k.CasteId;
    this.umsService.getCasteData(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        // this.isreadonlydel = true;
        this.deleteButton = true;
        const cleanedCategoryId = data.CategoryId.replace(/\|/g, '');
        this.CasteForm = this.fb.group({
          CategoryId: new FormControl(cleanedCategoryId, [Validators.required]),
          CasteName: new FormControl(data.CasteName, [Validators.required]),
          CasteId: new FormControl(data.CasteId),
          CasteCode: new FormControl(data.CasteCode),
          CasteNameM: new FormControl(data.CasteNameM),
          CategoryIdDefault: new FormControl(data.CategoryIdDefault),
          CasteStat: new FormControl(data.CasteStat),
          EntryStat: new FormControl(data.EntryStat),
          EntryBy: new FormControl(data.EntryBy),
        });
        this.CasteCodefordelete = this.CasteForm.value;
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
    // } else {
    //   this.list = true;
    // }
  }
  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.CasteCodefordelete);
      } else {
        // this.ngOnInit();
      }
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      // this.list = false;
      // this.isreadonly = false;
      this.getCasteData();
      // this.CountryForm = k;
      this.prepopulation(k);
    } else {
      // this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
